export default __webpack_public_path__ + "static/media/ic-faq.4011e99f.svg";